import React, { useCallback } from 'react'
import { usePaymentModalContext } from 'src/hooks/use-payment-modal-context'
import PaymentInfoDialog from '../payment-dialog/payment-dialog'
import CartDetailsTable from '../cart-payment-modal/cart-payment-modal'
import { RecordExternalOrderField } from 'src/screens/exception-queue/order-details-dialog/record-external-order-field'
import { useAppContext } from '@ftdr/blueprint-components-react'

const PaymentDialogsGroup = () => {
  const {
    appSettings: { localizedText },
  } = useAppContext()
  const {
    cartInfoModalOpen,
    setCartInfoModalOpen,
    setCartInfoModal,
    recordExternalOrderModalOpen,
    setRecordExternalOrderModalOpen,
    setRecordExternalOrderModal,
  } = usePaymentModalContext()

  const closeDialogCart = useCallback(() => {
    setCartInfoModalOpen(false)
    setCartInfoModal({})
    //eslint-disable-next-line
  }, [])

  const closeActionDialog = useCallback(() => {
    setRecordExternalOrderModalOpen(false)
    setRecordExternalOrderModal({})
    //eslint-disable-next-line
  }, [])

  return (
    <>
      <PaymentInfoDialog isOpen={cartInfoModalOpen} onClose={closeDialogCart}>
        <CartDetailsTable />
      </PaymentInfoDialog>
      <PaymentInfoDialog
        isOpen={recordExternalOrderModalOpen}
        onClose={closeActionDialog}
        className="appl-modal w-full max-w-lg sm:w-auto sm:min-w-md md:min-w-lg"
        header={localizedText('AGENT_CONFIRMATION_RECORD_EXTERNAL_ORDER')}
      >
        <RecordExternalOrderField onClose={closeActionDialog} />
      </PaymentInfoDialog>
    </>
  )
}

export default PaymentDialogsGroup
